"use strict";
/**
 * ************************************
 *
 * @module  next-persist
 * @author  most-js
 * @description a component that persists state to localStorage or cookies.
 *              this component should wrap Next.js components
 *              and be wrapped by Redux's Provider component
 *
 * ************************************
 */
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var setCookieStore_1 = require("./setCookieStore");
var setLocalStore_1 = require("./setLocalStore");
// type NextPersistWrapper = (props: WrapperProps) => React.ReactNode;
var NextPersistWrapper = function (props) {
    var state = react_redux_1.useSelector(function (state) { return state; });
    react_1.useEffect(function () {
        // determines method to persist state
        var method;
        if (props.wrapperConfig.method === 'localStorage') {
            method = setLocalStore_1.setLocalStore;
        }
        else if (props.wrapperConfig.method === 'cookies') {
            method = setCookieStore_1.setCookieStore;
        }
        else
            method = function () {
                return { err: 'No method detected' };
            };
        var allowList = props.wrapperConfig.allowList;
        var mockStorageConfig = {};
        // if no allowList - save all state to their corresponding keys
        if (!allowList) {
            var key = Object.keys(state)[0];
            mockStorageConfig[key] = [];
            method(mockStorageConfig, state[key]);
        }
        // if allowList - pass subconfigs of allowed reducers into storage method
        else {
            var allowedReducers = Object.keys(allowList);
            allowedReducers.forEach(function (allowedReducer) {
                mockStorageConfig[allowedReducer] = allowList[allowedReducer];
                method(mockStorageConfig, state[allowedReducer]);
            });
        }
    }, [state]);
    return props.children;
};
exports.default = NextPersistWrapper;
